module.exports = __webpack_public_path__ + "img/19044795@2x.d566fddd.jpg";